import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { ChartWrapper, PageWrapper, MiddleWidget } from "../assets/styled";
import Widgets from "../components/Widgets";
import Table from "../components/Table";
import { request } from "../commons/utils";
import { REPORT_SALES, REPORT_USERS, REPORT_WORDS } from "../commons/constants";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";

const Reports = () => {
  const [salesData, setSalesData] = useState(null);
  const [usersData, setUsersData] = useState(null);
  const [wordsData, setWordsData] = useState(null);

  useEffect(() => {
    const fetchReports = async () => {
      const salesResult = await request(REPORT_SALES, "GET", false, true);
      if (salesResult && salesResult.status) {
        setSalesData(salesResult.data);
      }

      const usersResult = await request(REPORT_USERS, "GET", false, true);
      if (usersResult && usersResult.status) {
        setUsersData(usersResult.data);
      }

      const wordsResult = await request(REPORT_WORDS, "GET", false, true);
      if (wordsResult && wordsResult.status) {
        setWordsData(wordsResult.data);
      }
    };
    fetchReports();
  }, []);

  const commonTheme = {
    axis: {
      ticks: {
        text: { fill: "rgba(255,255,255,0.7)" },
      },
      legend: {
        text: { fill: "#fff" },
      },
    },
    grid: {
      line: { stroke: "rgba(255,255,255,0.05)" },
    },
    tooltip: {
      container: { background: "#1A1A2E", color: "#fff" },
    },
  };

  const packageColumns = [
    { name: "name", text: "Paket Adı" },
    { name: "monthlyCount", text: "Bu Ay Satış (Adet)" },
    {
      name: "monthlyAmount",
      text: "Bu Ay Gelir",
      customBody: (val) =>
        new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
        }).format(val),
    },
    { name: "totalCount", text: "Toplam Satış (Adet)" },
    {
      name: "totalAmount",
      text: "Toplam Gelir",
      customBody: (val) =>
        new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
        }).format(val),
    },
  ];

  const languageColumns = [
    { name: "name", text: "Dil" },
    {
      name: "views",
      text: "Görüntülenen Kelime",
      customBody: (val) => new Intl.NumberFormat("tr-TR").format(val),
    },
  ];

  const userColumns = [
    { name: "user_id", text: "ID" },
    { name: "name", text: "Kullanıcı İsim/Mail" },
    {
      name: "views",
      text: "Kelime Görüntüleme",
      customBody: (val) => new Intl.NumberFormat("tr-TR").format(val),
    },
  ];

  const formattedDailyUsers = [
    {
      id: "Kullanıcılar",
      color: "#00F2FF",
      data: usersData?.daily?.map((d) => ({ x: d.label, y: d.count })) || [],
    },
  ];

  return (
    <PageWrapper>
      <Grid container spacing={3}>
        {/* Kullanıcı Özeti */}
        <Grid item lg={3} md={6} sm={12} xs={12}>
          <Widgets
            type="sm"
            title="Toplam Kullanıcı"
            numberData={new Intl.NumberFormat("tr-TR").format(
              usersData?.totalUsers || 0,
            )}
            accentColor="#00F2FF"
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12} xs={12}>
          <Widgets
            type="sm"
            title="Onaylı Kullanıcılar"
            numberData={new Intl.NumberFormat("tr-TR").format(
              usersData?.activatedUsers || 0,
            )}
            accentColor="#9D00FF"
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12} xs={12}>
          <Widgets
            type="sm"
            title="Son 30 Gün Kayıt"
            numberData={new Intl.NumberFormat("tr-TR").format(
              usersData?.last30DaysUsers || 0,
            )}
            accentColor="#00FF85"
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12} xs={12}>
          <Widgets
            type="sm"
            title="Bu Ay Kayıt"
            numberData={new Intl.NumberFormat("tr-TR").format(
              usersData?.thisMonthUsers || 0,
            )}
            accentColor="#FF9900"
          />
        </Grid>

        {/* Kayıt Kaynakları */}
        {usersData?.registrationSources && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <MiddleWidget>
              <div className="header">
                <h5
                  style={{
                    color: "#fff",
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    borderLeft: "5px solid #00F2FF",
                    paddingLeft: 15,
                    letterSpacing: "0.5px",
                    marginBottom: 15,
                  }}
                >
                  Kayıt Kaynakları
                </h5>
              </div>
              <div
                className="content"
                style={{
                  display: "flex",
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                {Object.entries(usersData.registrationSources).map(
                  ([name, count], index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.03)",
                        border: "1px solid rgba(255, 255, 255, 0.08)",
                        borderRadius: "16px",
                        padding: "8px 16px",
                        transition: "all 0.2s ease",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                      }}
                    >
                      <span
                        style={{
                          color: "rgba(255, 255, 255, 0.6)",
                          fontSize: "0.9rem",
                          marginRight: 10,
                          fontWeight: "600",
                        }}
                      >
                        {name}
                      </span>
                      <span
                        style={{
                          color: "#00F2FF",
                          fontSize: "1.1rem",
                          fontWeight: "800",
                          background: "rgba(0, 242, 255, 0.1)",
                          padding: "2px 10px",
                          borderRadius: "10px",
                        }}
                      >
                        {new Intl.NumberFormat("tr-TR").format(count)}
                      </span>
                    </div>
                  ),
                )}
              </div>
            </MiddleWidget>
          </Grid>
        )}

        {/* Kullanıcı Grafiği */}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <h3 style={{ color: "#fff", marginBottom: 15, paddingLeft: 10 }}>
            Son 30 Günlük Kayıtlar
          </h3>
          <ChartWrapper height="400px">
            {usersData && (
              <ResponsiveLine
                data={formattedDailyUsers}
                margin={{ top: 20, right: 30, bottom: 70, left: 50 }}
                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: "auto",
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -45,
                  legend: "Tarih",
                  legendOffset: 60,
                  legendPosition: "middle",
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Kişi",
                  legendOffset: -40,
                  legendPosition: "middle",
                }}
                theme={commonTheme}
                pointSize={10}
                pointColor={{ theme: "background" }}
                pointBorderWidth={2}
                pointBorderColor={{ from: "serieColor" }}
                enableArea={true}
                useMesh={true}
                colors={["#00F2FF"]}
                tooltip={({ point }) => (
                  <div
                    style={{
                      background: "#1A1A2E",
                      padding: "10px",
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                  >
                    tarih: {point.data.x} kayıt: {point.data.y}
                  </div>
                )}
              />
            )}
          </ChartWrapper>
        </Grid>

        {/* Satış Grafikleri */}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <h3 style={{ color: "#fff", marginBottom: 15, paddingLeft: 10 }}>
            Aylık Satış Tutarı Analizi
          </h3>
          <ChartWrapper height="400px">
            {salesData && (
              <ResponsiveBar
                data={salesData.monthly || []}
                keys={["totalAmount"]}
                indexBy="label"
                margin={{ top: 20, right: 30, bottom: 70, left: 70 }}
                padding={0.3}
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}
                colors={["#FF9900"]}
                enableLabel={false}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -45,
                  legend: "Ay",
                  legendPosition: "middle",
                  legendOffset: 60,
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Tutar (TL)",
                  legendPosition: "middle",
                  legendOffset: -60,
                }}
                theme={commonTheme}
                tooltip={({ value, data }) => (
                  <div
                    style={{
                      background: "#1A1A2E",
                      padding: "10px",
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                  >
                    tarih: {data.label} satış:{" "}
                    {new Intl.NumberFormat("tr-TR", {
                      style: "currency",
                      currency: "TRY",
                    }).format(value)}
                  </div>
                )}
              />
            )}
          </ChartWrapper>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <h3 style={{ color: "#fff", marginBottom: 15, paddingLeft: 10 }}>
            Aylık Satılan Paket Adeti
          </h3>
          <ChartWrapper height="400px">
            {salesData && (
              <ResponsiveBar
                data={salesData.monthly || []}
                keys={["count"]}
                indexBy="label"
                margin={{ top: 20, right: 30, bottom: 70, left: 70 }}
                padding={0.3}
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}
                colors={["#00FF85"]}
                enableLabel={true}
                labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -45,
                  legend: "Ay",
                  legendPosition: "middle",
                  legendOffset: 60,
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Adet",
                  legendPosition: "middle",
                  legendOffset: -60,
                }}
                theme={commonTheme}
                tooltip={({ value, data }) => (
                  <div
                    style={{
                      background: "#1A1A2E",
                      padding: "10px",
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                  >
                    tarih: {data.label} adet: {value}
                  </div>
                )}
              />
            )}
          </ChartWrapper>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <h3 style={{ color: "#fff", marginBottom: 15, paddingLeft: 10 }}>
            Günlük Satışlar (Son 30 Gün)
          </h3>
          <ChartWrapper height="400px">
            {salesData && (
              <ResponsiveBar
                data={salesData.daily || []}
                keys={["totalAmount"]}
                indexBy="label"
                margin={{ top: 20, right: 30, bottom: 70, left: 70 }}
                padding={0.3}
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}
                colors={["#9D00FF"]}
                enableLabel={false}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -45,
                  legend: "Gün",
                  legendPosition: "middle",
                  legendOffset: 60,
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Tutar (TL)",
                  legendPosition: "middle",
                  legendOffset: -60,
                }}
                theme={commonTheme}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
                tooltip={({ value, data }) => (
                  <div
                    style={{
                      background: "#1A1A2E",
                      padding: "10px",
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                  >
                    tarih: {data.label} satış:{" "}
                    {new Intl.NumberFormat("tr-TR", {
                      style: "currency",
                      currency: "TRY",
                    }).format(value)}
                  </div>
                )}
              />
            )}
          </ChartWrapper>
        </Grid>

        {/* Paket Satışları Tablosu */}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <h3 style={{ color: "#fff", marginBottom: 15, paddingLeft: 10 }}>
            Paket Satış İstatistikleri
          </h3>
          <ChartWrapper
            height="auto"
            style={{ padding: "20px", overflowX: "auto", overflowY: "hidden" }}
          >
            {salesData && salesData.packageTable && (
              <Table
                id="package_sales_table"
                data={salesData.packageTable}
                columns={packageColumns}
                options={{
                  pagination: { active: true, perPage: 5 },
                  header: { visible: false },
                  selectableRows: "none",
                  editable: false,
                }}
              />
            )}
          </ChartWrapper>
        </Grid>

        {/* Kelime Özeti */}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Widgets
            type="sm"
            title="Toplam Tekil Görüntülenme Sayısı"
            numberData={new Intl.NumberFormat("tr-TR").format(
              wordsData?.totalUniqueViews || 0,
            )}
            accentColor="#FF007F"
          />
        </Grid>

        {/* En Aktif Kullanıcılar Tablosu */}
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <h3 style={{ color: "#fff", marginBottom: 15, paddingLeft: 10 }}>
            En Aktif 10 Kullanıcı
          </h3>
          <ChartWrapper
            height="auto"
            style={{ padding: "20px", overflowX: "auto", overflowY: "hidden" }}
          >
            {wordsData && wordsData.topUsersTable && (
              <Table
                id="top_users_table"
                data={wordsData.topUsersTable}
                columns={userColumns}
                options={{
                  pagination: { active: false },
                  header: { visible: false },
                  selectableRows: "none",
                  editable: false,
                }}
              />
            )}
          </ChartWrapper>
        </Grid>

        {/* En Aktif Dil Tablosu */}
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <h3 style={{ color: "#fff", marginBottom: 15, paddingLeft: 10 }}>
            En Aktif Dil
          </h3>
          <ChartWrapper
            height="auto"
            style={{ padding: "20px", overflowX: "auto", overflowY: "hidden" }}
          >
            {wordsData && wordsData.languageTable && (
              <Table
                id="language_table"
                data={wordsData.languageTable}
                columns={languageColumns}
                options={{
                  pagination: { active: false },
                  header: { visible: false },
                  selectableRows: "none",
                  editable: false,
                }}
              />
            )}
          </ChartWrapper>
        </Grid>
      </Grid>
    </PageWrapper>
  );
};

export default Reports;
